import React, { useEffect, useState } from "react";
import { getPermits } from "../../api/permit";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../utils/date";
import PageHeader from "../../components/common/ui/PageHeader";

export default function PermitMilestones() {
  const [permits, setPermits] = useState([]);
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  useEffect(() => {
    (async () => {
      const data = await getPermits({
        page: 1,
        page_size: 9999,
        ordering: "planned_date",
      });
      const all = data.results || data;
      setPermits(all);
    })();
  }, []);

  const statusColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-500";
      case "delayed":
        return "bg-red-500";
      case "planned":
        return "bg-yellow-500";
      case "in_progress":
        return "bg-indigo-500";
      default:
        return "bg-gray-400";
    }
  };

  const statusText = (status) => {
    switch (status) {
      case "completed":
        return "완료";
      case "delayed":
        return "지연";
      case "planned":
        return "계획";
      case "in_progress":
        return "진행중";
      default:
        return "알수없음";
    }
  };

  // 날짜별 그룹핑
  const grouped = permits.reduce((acc, p) => {
    const date = p.planned_date ? formatDate(p.planned_date) : "-";
    if (!acc[date]) acc[date] = [];
    acc[date].push(p);
    return acc;
  }, {});

  const dates = Object.keys(grouped).sort();

  return (
    <div className="p-6">
      <PageHeader>
        인허가 일정
      </PageHeader>

      <div className="flex flex-wrap gap-y-8 justify-start bg-white border p-6 rounded-lg shadow-sm mt-6 overflow-x-auto">
        {dates.map((date) => (
          <div
            key={date}
            className="flex flex-col items-center min-w-[140px] relative"
          >
            {/* 선 */}
            <div className="absolute top-2 left-0 right-0 border-t border-slate-200 z-0"></div>

            {/* 점 */}
            <span className="w-4 h-4 rounded-full bg-slate-400 border border-white shadow-sm z-10"></span>

            {/* 날짜 */}
            <p className="mt-1 text-xs font-medium text-slate-600">{date}</p>

            {/* 카드들 */}
            <div className="mt-1 space-y-1.5 w-full">
              {grouped[date].map((p) => (
                <div
                  key={p.id}
                  onClick={() =>
                    navigate(`/project/${projectId}/permit/view/${p.doc_dns}`)
                  } // ✅ 상세페이지 이동
                  className="p-1.5 text-xs"
                >
                  <div className="flex items-center justify-center gap-1">
                    <span
                      className={`w-2 h-2 rounded-full ${statusColor(
                        p.status
                      )}`}
                    />
                    <span className="truncate">{p.name}</span>
                  </div>
                  <div className="text-[10px] text-slate-400 text-center">
                    {statusText(p.status)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
